import requestApi, { ErrorResponse, HTTP_METHOD } from '@/utils/axios.http';
import { ResetPasswordAuthDTO, sendEmailDTO } from '../dto/auth';
import { AuthResponse } from '../entities/auth';
import axios, { AxiosResponse } from 'axios';
import { TLoginSchema } from '@/schemas/auth/login.schema';
import { API_BASE_URL } from '@/utils/constant.utils';

const AUTH_URI = '/auth';

export const logIn = async (
  credentials: TLoginSchema
): Promise<AuthResponse | ErrorResponse> => {
  return requestApi({
    url: `${AUTH_URI}/login`,
    method: HTTP_METHOD.POST,
    body: credentials,
    headers: {
      'Content-Type': 'application/json',
    },
  });
};

export const logInByUserId = async (
  userId: string
): Promise<AuthResponse | ErrorResponse> => {
  return requestApi({
    url: `${AUTH_URI}/loginByUserId`,
    method: HTTP_METHOD.POST,
    body: { userId },
    headers: {
      'Content-Type': 'application/json',
    },
  });
};

export const logout = async (): Promise<AxiosResponse | ErrorResponse> => {
  return requestApi({
    url: `${AUTH_URI}/logout`,
    method: HTTP_METHOD.DELETE,
  });
};

export const refreshToken = async (): Promise<AuthResponse> => {
  const response = await axios.post(
    `${API_BASE_URL}${AUTH_URI}/refresh`,
    {},
    { withCredentials: true }
  );
  return response as AuthResponse;
};

export const sendEmailRestPassword = async (
  sendEmailDTO: sendEmailDTO
): Promise<AxiosResponse | ErrorResponse> => {
  return requestApi({
    url: `${AUTH_URI}/send-email-reset-password`,
    method: HTTP_METHOD.POST,
    body: sendEmailDTO,
    headers: {
      'Content-Type': 'application/json',
    },
  });
};

export const resetPassword = async (
  resetPasswordDTO: ResetPasswordAuthDTO
): Promise<AxiosResponse | ErrorResponse> => {
  return requestApi({
    url: `${AUTH_URI}/reset-password`,
    method: HTTP_METHOD.PUT,
    body: resetPasswordDTO,
    headers: {
      'Content-Type': 'application/json',
    },
  });
};
